import { inPlaceSort } from 'fast-sort';
import { useEffect, useState } from 'react';
import { FaTrashCan } from 'react-icons/fa6';
import { LabelCreatable } from '../../../../components/Input/Input';
import { alertSuccess } from '../../../../components/Toast';
import { supabase } from '../../../../supabaseClient';

export const useConsultants = ({
  company,
  setReloadPrint,
  setValues,
  onChange,
  values,
  reloadConsultants,
  setConsultantState,
}) => {
  const [consultants, setConsultants] = useState([]);

  useEffect(() => {
    loadConsultants();
  }, [company.id, reloadConsultants]);

  const loadConsultants = async () => {
    let { data, error } = await supabase
      .from('CompanyConsultant')
      .select('*')
      .eq('company_id', company.id)
      .is('deleted_at', null);

    if (!error) {
      const mappedData = data.map((item) => ({ ...item, label: item.name, value: item.id }));
      setConsultants(mappedData);

      // setConsultantState é opcional - só chama se foi fornecido
      if (setConsultantState && typeof setConsultantState === 'function') {
        setConsultantState(mappedData);
      }
    }
  };

  const deleteConsultantOption = async (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    const { error } = await supabase
      .from('CompanyConsultant')
      .update({ deleted_at: new Date() })
      .eq('id', id);

    if (!error) {
      setConsultants(
        consultants.filter((options) => options.id !== parseInt(id))
      );
      alertSuccess('Deletado com sucesso');
    }
  };

  const createConsultantOption = async (name, field) => {
    setReloadPrint((reload) => !reload);
    setValues((values) => ({
      ...values,
      [field]: { label: name, value: '0' },
    }));
  };

  const divCreatableConsultant = (data, e) => {
    if (data.id) {
      e.preventDefault();
      onChange('id_consultant', { label: data.label, value: data.id });
    } else {
      setValues((values) => ({
        ...values,
        id_consultant: { label: data.value, value: '0' },
      }));
    }
    setReloadPrint((reload) => !reload);
  };

  const sortedConsultantsOptions = consultants.map((item) => ({
    value: item.value,
    label: item.label,
    id: item.id,
  }));

  inPlaceSort(consultants).asc([
    (item) => item.label?.replace(/[^a-zA-Z]/g, '').toLowerCase(),
    (item) => {
      const numberMatch = item.label?.match(/\d+/);
      return numberMatch ? parseInt(numberMatch[0], 10) : 0;
    },
  ]);

  const OptionFuncConsultant = (props) => {
    const { data } = props;
    return (
      <div
        {...props}
        className="deletable-creatable"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '40px',
          padding: '10px',
        }}
      >
        <div
          onClick={(e) => divCreatableConsultant(data, e)}
          style={{
            textTransform: 'uppercase',
            width: '100%',
            height: '40px',
            alignContent: 'center',
          }}
        >
          {data?.label}
        </div>
        <div>
          <FaTrashCan
            style={{ color: 'rgb(255 130 120)' }}
            onClick={(e) => deleteConsultantOption(data.id, e)}
          />
        </div>
      </div>
    );
  };

  const InputConsultant = () => (
    <div className="payment-dropdown">
      <div className="void-class">
        <LabelCreatable
          onCreateOption={(name) =>
            createConsultantOption(name, 'id_consultant')
          }
          components={{ Option: (props) => OptionFuncConsultant(props) }}
          options={inPlaceSort(sortedConsultantsOptions).asc([
            (item) => item.label?.replace(/[^a-zA-Z]/g, '').toLowerCase(),
            (item) => {
              const numberMatch = item.label?.match(/\d+/);
              return numberMatch ? parseInt(numberMatch[0], 10) : 0;
            },
          ])}
          defaultValue={
            typeof values?.id_consultant === 'object'
              ? values.id_consultant
              : consultants.find((item) => item.id === values?.id_consultant)
          }
          onChange={(value) => onChange('id_consultant', value)}
          placeholder={'INSIRA O CONSULTOR'}
          label={'Consultor'}
          className="generic-input select-creatable budget-percentage-input budget-creatable"
          styles={{
            option: (base) => ({
              ...base,
              border: ``,
              height: '100%',
            }),
          }}
        />
      </div>
    </div>
  );

  return {
    InputConsultant,
  };
};
